module.exports = __webpack_public_path__ + "img/worksbot_img20022512.19995404.jpg";